import { CheckoutStatus } from '../../stripe/enums';
import { Party } from '../models';

// A stripe checkout hold that has not been paid: the booking is not confirmed. Stays true
// after a payment-timeout cancel (status remains inProgress; only cancelReason is stamped),
// so it also identifies abandoned holds. Restaurant-facing notifications, integrations and
// reporting treat such a party as not existing yet.
export function hasUnpaidCheckout(party: Pick<Party, 'stripeData'> | null | undefined): boolean {
  return party?.stripeData?.status === CheckoutStatus.inProgress;
}

// True exactly once per confirmation: the checkout went from unpaid to PAID. Requires the
// paid status explicitly — unpaid -> refunded (a deposit that raced a deliberate cancel,
// `paidMidCancel`) is not a confirmation and must not announce or create records.
export function isCheckoutPaidTransition(
  previousParty: Pick<Party, 'stripeData'> | null | undefined,
  party: Pick<Party, 'stripeData'> | null | undefined,
): boolean {
  return hasUnpaidCheckout(previousParty) && party?.stripeData?.status === CheckoutStatus.paid;
}
